import React, { useEffect, useState } from "react";
import styles from "./Register.module.css";

import { InputText } from "primereact/inputtext";
import { FloatLabel } from 'primereact/floatlabel';
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../../store/auth-store/auth-slice";

import DataLabLogo from "../../../assets/img/DataLabLogo.png";
import { RegisterUser } from "../../../store/auth-store/auth-actions";
import Loading from "../../../components/UI/loading/Loading";


const Register = () => {

  const auth = useSelector((state) => state.auth.auth);
  const dispatch = useDispatch();
  const [invalidField, setInvalidField] = useState("");
  const [filledInputs, setFilledInputs] = useState({
    name: false,
    lastName: false,
    email: false,
    password: false,
  });
  const [focused, setFocused] = useState({
    name: false,
    lastName: false,
    email: false,
    password: false,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  },);

  const handleBlur = (field) => {
    setFocused((prev) => ({ ...prev, [field]: false }));
    setFilledInputs((prev) => ({ ...prev, [field]: prev[field] }));
  };

  const handleFocus = (field) => {
    setFocused((prev) => ({ ...prev, [field]: true }));
  };

  const onChangeHandler = (id, value) => {
    setInvalidField("");
    setFilledInputs((prev) => ({ ...prev, [id]: value.length > 0 }));
    dispatch(authActions.modifyPropertyValue({ id, value }));

    if (value !== "") {
      dispatch(authActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(authActions.setFieldValid({ id, value: false }));
    }
  };

  const goToLogin = (e) => {
    window.location.href = "/";
  };

  const onSubmitHandler = async (event) => {

    setInvalidField("");

    if (auth.name === "") {
      setInvalidField("name");
      return;
    } else if (auth.lastName === "") {
      setInvalidField("lastName");
      return;
    } else if (auth.email === "") {
      setInvalidField("email");
      return;
    } else if (auth.password === "") {
      setInvalidField("password");
      return;
    }

    dispatch(RegisterUser(auth));
    // window.location.href = "/";
  };

  if (isLoading) {
    return <Loading />;
}

  return (
    <>
      {auth !== null && auth !== undefined && auth !== "" && (
        <div className={`${styles.registerContainer} flex justify-content-center align-items-center`}>
          <div className={`${styles.registerCard} surface-card px-6 py-6 shadow-2 grid grid-nogutter`}>
            <i onClick={() => goToLogin()} className={`pi pi-arrow-left ${styles.goBackIcon}`}></i>
            <div className={styles.registerFields}>
              <h2 className={`${styles.textCenter} text-2xl`}>Registro</h2>
              <div className="flex flex-column gap-3">
                <FloatLabel>
                  <InputText
                    id="name"
                    placeholder=" "
                    name="name"
                    type="text"
                    label="Nombre"
                    value={auth.name}
                    onBlur={() => handleBlur("name")}
                    onFocus={() => handleFocus("name")}
                    onChange={(e) => onChangeHandler("name", e.target.value)}
                    className={`${styles.InputFields} ${invalidField === "name" ? "p-invalid" : ""}`}
                    invalid={invalidField === "name"}
                  // aria-describedby="name-help"
                  />
                  <label htmlFor="name" className={styles.InputFields}>Nombre</label>
                </FloatLabel >

                {invalidField === "name" && (
                  <small id="name-help" className={`${styles.inputWarningText}`}>El campo nombre no puede estar vacío</small>
                )}

                <FloatLabel className={filledInputs.lastName || focused.lastName ? "mt-4" : "mt-0"}>
                  <InputText
                    id="lastName"
                    name="lastName"
                    type="text"
                    label="Apellido"
                    value={auth.lastName !== undefined ? auth.lastName : ""}
                    onFocus={() => handleFocus("lastName")}
                    onBlur={() => handleBlur("lastName")}
                    onChange={(e) => onChangeHandler("lastName", e.target.value)}
                    className={styles.InputFields}
                    invalid={invalidField === "lastName"}
                  />
                  <label className={styles.InputFields}>Apellido</label>
                </FloatLabel>
                {invalidField === "lastName" && (
                  <small id="lastName-help" className={`${styles.inputWarningText}`}>El campo apellido no puede estar vacío</small>
                )}
                <FloatLabel className={filledInputs.email || focused.email ? "mt-4" : "mt-0"}>
                  <InputText
                    id="email"
                    name="email"
                    type="text"
                    label="Correo Electrónico"
                    value={auth.email !== undefined ? auth.email : ""}
                    onFocus={() => handleFocus("email")}
                    onBlur={() => handleBlur("email")}
                    onChange={(e) => onChangeHandler("email", e.target.value)}
                    className={styles.InputFields}
                    invalid={invalidField === "email"}
                  />
                  <label className={styles.InputFields}>Correo Electrónico</label>
                </FloatLabel>
                {invalidField === "email" && (
                  <small id="email-help" className={`${styles.inputWarningText}`}>El campo correo electrónico no puede estar vacío</small>
                )}

                <FloatLabel className={filledInputs.password || focused.password ? "mt-4" : "mt-0"}>
                  <Password
                    id="password"
                    name="password"
                    label="Contraseña"
                    value={auth.password !== undefined ? auth.password : ""}
                    onFocus={() => handleFocus("password")}
                    onBlur={() => handleBlur("password")}
                    onChange={(e) => onChangeHandler("password", e.target.value)}
                    className={styles.InputFields}
                    feedback={false}
                    invalid={invalidField === "password"}
                  />
                  <label className={styles.InputFields}>Contraseña</label>
                </FloatLabel>
                {invalidField === "password" && (
                  <small id="password-help" className={`${styles.inputWarningText}`}>El campo contraseña no puede estar vacío</small>
                )}
                <Button onClick={() => onSubmitHandler()} label="Crear usuario" type="submit" className={`${styles.registerButton} p-button-primary mt-1`} />
              </div>
            </div>
          </div>
          <div className={styles.logoContainer}>
            <img src={DataLabLogo} alt="PrimeReact Logo" className={`${styles.logo} mb-4`} />
          </div>
        </div>
      )}
    </>
  );
};

export default Register;
